import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from '../../../context/AuthContext';
import axios from "axios";
import Swal from 'sweetalert2';

const PaymentRequest = () => {
    const { t } = useTranslation();
    const { user } = useAuth();

    const [banksdata, setbanksdata] = useState([]);
    const [packages, setPackages] = useState([]);
    const [msg, setMsg] = useState("");

    const headerss = {
        "accept": "*/*",
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": "false",
        "Authorization": "Bearer " + user.token
    };

    const handlePaymentStudent = async (e) => {
        e.preventDefault();
        try {
            const res = await axios.post(
                "https://api.heryerdeingilizce.com/api/user/Subscription/Apply",
                {
                    gatewayId: document.getElementById("studentbankId").value,
                    package: document.getElementById("studentpackageId").value,
                },
                { headers: headerss }
            );

            if (res.data.success) {
                Swal.fire("Başarılı", "Ödeme talebiniz alınmıştır", "success");
            } else {
                setMsg(res.data.message);
            }
        } catch (err) {
            setMsg(err.message);
        }
    };

    const handlePaymentStudentCoupen = async (e) => {
        e.preventDefault();
        try {
            const res = await axios.post(
                "https://api.heryerdeingilizce.com/api/user/Subscription/ApplyCupon",
                {
                    packageId: document.getElementById("coupenpackageId").value,
                    cuponCode: document.getElementById("coupencode").value,
                },
                { headers: headerss }
            );

            if (res.data.success) {
                Swal.fire("Başarılı", "Ödeme talebiniz alınmıştır", "success");
            } else {
                Swal.fire("Hata", res.data.message, "error");
            }
        } catch (err) {
            setMsg(err.message);
        }
    };

    const getBanks = async () => {
        try {
            const res = await axios.get(
                "https://api.heryerdeingilizce.com/api/User/GetGateways",
                { headers: headerss }
            );

            if (res.data.success) {
                const activeBanks = res.data.data.filter(x => x.isActive);
                setbanksdata(activeBanks);
            }
        } catch (err) {
            setMsg(err.message);
        }
    };

    const fetchDataPackages = async () => {
        try {
            const res = await axios.get(
                "https://api.heryerdeingilizce.com/api/User/GetPackages",
                { headers: headerss }
            );

            if (res.data.success) {
                const filtered = res.data.data.filter(p =>
                    p.isActive &&
                    ((user.role === "Öğrenci" && p.isInvidual) ||
                        (user.role === "Yönetici" && !p.isInvidual))
                );
                setPackages(filtered);
            }
        } catch (err) {
            setMsg(err.message);
        }
    };

    useEffect(() => {
        getBanks();
        fetchDataPackages();
    }, []);

    return (
        <div className="container my-5">
            <div className="card shadow-sm">
                <div className="card-body">
                    <h4 className="text-center mb-4">
                        {t('paymentRequest')}
                    </h4>

                    {msg && (
                        <div className="alert alert-warning text-center">
                            {msg}
                        </div>
                    )}

                    <div className="row g-4">
                        {/* SOL KOLON */}
                        <div className="col-md-6">
                            <div className="card h-100 border-secondary">
                                <div className="card-body">
                                    <h5 className="text-center mb-3">
                                        {t('usingpaymentmethod')}
                                    </h5>

                                    {user.user.roleName === "Student" && (
                                        <form onSubmit={handlePaymentStudent}>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    {t('selectBank')}
                                                </label>
                                                <select
                                                    id="studentbankId"
                                                    className="form-select"
                                                >
                                                    <option value="">
                                                        {t('selectBank')}
                                                    </option>
                                                    {banksdata.map(dt => (
                                                        <option key={dt.id} value={dt.id}>
                                                            {dt.gatewayName} & {dt.typeName}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="mb-3">
                                                <label className="form-label">
                                                    {t('selectPackage')}
                                                </label>
                                                <select
                                                    id="studentpackageId"
                                                    className="form-select"
                                                >
                                                    <option value="">
                                                        {t('selectPackage')}
                                                    </option>
                                                    {packages.map(dt => (
                                                        <option key={dt.id} value={dt.id}>
                                                            {dt.packageName}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="d-grid">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary btn-lg"
                                                >
                                                    {t('create')}
                                                </button>
                                            </div>
                                        </form>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* SAĞ KOLON */}
                        <div className="col-md-6">
                            <div className="card h-100 border-secondary">
                                <div className="card-body">
                                    <h5 className="text-center mb-3">
                                        {t('usingcoupencode')}
                                    </h5>

                                    {user.user.roleName === "Student" && (
                                        <form onSubmit={handlePaymentStudentCoupen}>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    {t('selectPackage')}
                                                </label>
                                                <select
                                                    id="coupenpackageId"
                                                    className="form-select"
                                                >
                                                    <option value="">
                                                        {t('selectPackage')}
                                                    </option>
                                                    {packages.map(dt => (
                                                        <option key={dt.id} value={dt.id}>
                                                            {dt.packageName}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="mb-3">
                                                <label className="form-label">
                                                    {t('coupencode')}
                                                </label>
                                                <textarea
                                                    id="coupencode"
                                                    className="form-control"
                                                    rows="1"
                                                    required
                                                />
                                            </div>

                                            <div className="d-grid">
                                                <button
                                                    type="submit"
                                                    className="btn btn-success btn-lg"
                                                >
                                                    {t('create')}
                                                </button>
                                            </div>
                                        </form>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default PaymentRequest;
